export const RedemptionHistoryKeys: any = {
    fullName: "Name",
    points: "Points Redeemed",
    redemptionStatus: "Status",
    redemptionMode: "Redemption Mode",
    accountNumber: "Account Number",
    ifscCode: "IFSC Code",
    accountType: "Account Type",
    accountHolderName: "Account Holder Name",
    upiId: "UPI ID",
    createdAt: "Upload Date",
};

export const ApproveRejectRedemptionKeys: any = {
    id: "Id",
    fullName: "Name",
    points: "Points Redeemed",
    redemptionStatus: "Status",
    redemptionMode: "Redemption Mode",
    accountNumber: "Account Number",
    ifscCode: "IFSC Code",
    accountType: "Account Type",
    accountHolderName: "Account Holder Name",
    upiId: "UPI ID",
    createdAt: "Upload Date",
    branchName: "Branch Name",
    userId: "User ID",
    ipAddress: "IP Address",
    source: "Source",
    longitude: "Longitude",
    latitude: "Latitude",
    updatedAt: "Updated At",
    message: "Message",
    firstName: "First Name",
    lastName: "Last Name",
};

export const KycReportKeys: any = {
    fullName: "Name",
    documentType: "Document Type",
    message: "Message",
    status: "Status",
    createdAt: "Upload Date",
};

export const TicketsReportKeys: any = {
    fullName: "Name",
    category: "Category",
    referenceNumber: "Reference Number",
    description: "Description",
    status: "Status",
    createdAt: "Upload Date",
    resolutionNotes: "Resolution Notes",
};

export const ScanHistoryKeys: any = {
    userName: "User Name",
    userMobile: "Mobile",
    userEmail: "Email",
    serialNumber: "Serial Number",
    skuCode: "SKU Code",
    points: "Points",
    scanStatus: "Status",
    scanMessage: "Message",
    source: "Source",
    ip: "IP Address",
    createdAt: "Scan Date",
};
